import React, { useContext, useEffect, useRef, useState } from "react";
import Add from "../../../Assets/Icons/Add icon.svg";
import Edit from "../../../Assets/Icons/edit.svg";
import Delete from "../../../Assets/Icons/delete.svg";
import ConsultationService from "../../../Services/ConsultationService";
import { message } from "antd";
import CommonFunctions from "../../Shared/CommonFunctions";
import { RxCross2 } from "react-icons/rx";
import { VoiceCommandContext } from "../VoiceCommand/VoiceContext";

function LabTest({
  labPrescription,
  setLabPrescription,
  appointmentDetails,
  suggestiveData,
  selectedSymObj,
}) {
  const [labList, setLablist] = useState([]);
  const [labName, setLabName] = useState("");
  const [selectedLab, setSelectedLab] = useState({});
  const [suggestiveLabList, setSuggestiveLabList] = useState([]);
  const lastSearchedValueRef = useRef("");
  const fromSuggestionClick = useRef(false);

  useEffect(() => {
    if (fromSuggestionClick.current && selectedLab) {
      handleLabTestSave(selectedLab);
      fromSuggestionClick.current = false;
    }
  }, [selectedLab]);

  useEffect(() => {
    setSuggestiveLabList(selectedSymObj?.diagnosisLabTestMasterList);
  }, [selectedSymObj?.diagnosisLabTestMasterList]);

  const {
    labTestVoice,
    setLabTestVoice,
    deleteLabTestVoice,
    setDeleteLabTestVoice,
    selectAllVoice,
    setSelectAllVoice,
  } = useContext(VoiceCommandContext);

  useEffect(() => {
    setSuggestiveLabList(suggestiveData?.diagnosisLabTestMasterList);
  }, [suggestiveData?.diagnosisLabTestMasterList]);

  useEffect(() => {
    if (labTestVoice) {
      if (labTestVoice.toLowerCase().includes("select all")) return;
      lastSearchedValueRef.current = labTestVoice;
      onSearchLab(labTestVoice); // triggers labList update

      // Reset voice input to avoid repeat triggers
      setLabTestVoice("");
    }
  }, [labTestVoice]);

  useEffect(() => {
    if (!deleteLabTestVoice) return;

    const lowerVoice = deleteLabTestVoice.toLowerCase();

    const matchedLab = labPrescription.find((lab) =>
      lab?.labTestName?.toLowerCase().includes(lowerVoice)
    );

    if (matchedLab) {
      handleDelete(matchedLab);
      message.success(`Deleted lab test: ${matchedLab.labTestName}`);
    } else {
      message.error(`No matching lab test found: "${deleteLabTestVoice}"`);
    }

    setDeleteLabTestVoice("");
  }, [deleteLabTestVoice]);

  useEffect(() => {
    if (selectAllVoice === "labtest") {
      handleAllLabSel();
      message.success("✅ All Lab Tests selected");
      setSelectAllVoice(""); // reset
    }
  }, [selectAllVoice]);

  useEffect(() => {
    const voiceInput = lastSearchedValueRef.current;
    if (voiceInput) {
      const matched = labList.find((lab) =>
        lab.name.toLowerCase().includes(voiceInput.toLowerCase())
      );

      if (matched) {
        setSelectedLab(matched);
        setLabName(matched.name);
        setLablist([]);
        message.success(`Voice selected: ${matched.name}`);
      } else {
        setLabName(voiceInput);
        message.success(`Voice typed: ${voiceInput}`);
      }

      // Clear the ref
      lastSearchedValueRef.current = "";
    }
  }, [labList]);

  const handleLabTestSave = (labItem) => {
    if (!labItem && labName === "") {
      message.error("Enter Lab Test Name");
      return;
    }
    let payload = {
      code: labItem?.code ? labItem?.code : labName,
      name: labItem?.name ? labItem?.name : labName,
      parentId: labItem?.parentId ? labItem?.parentId : labItem?.name,
      status: 1,
      createdBy: appointmentDetails.userId,
      modifiedBy: appointmentDetails.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      labtestcategoryId: labItem.labtestcategoryId
        ? labItem?.labtestcategoryId
        : labItem?.name,
      labtestdiseaseId: labItem.labtestdiseaseId
        ? labItem?.labtestdiseaseId
        : labItem?.name,
      parentDescription: labItem.parentDescription
        ? labItem?.parentDescription
        : labItem?.name,
      labTestId: labItem.code ? labItem?.code : labName,
      labTestName: labItem.name ? labItem?.name : labName,
      account_Id: appointmentDetails.account_Id,
      clinic_Id: appointmentDetails.clinic_Id,
      documentReceivedSource: null,
      parentLabTestName: labItem.parentDescription
        ? labItem?.parentDescription
        : labItem?.name,
      patientId: appointmentDetails.patientId,
      userId: appointmentDetails.userId,
    };

    setLabPrescription((prevData) => {
      const isAlreadyPresent = prevData.some(
        (item) => item.code === payload.code
      );

      if (isAlreadyPresent) {
        message.error("Lab Test is already present");
        return prevData;
      } else {
        setLabName("");
        setSelectedLab({});
        return [...prevData, payload];
      }
    });
  };

  const handleLabChange = (value) => {
    setLabName(value);
  };

  const onSearchLab = async (value) => {
    if (value.length > 2) {
      let result = await ConsultationService.LabTest(value);
      setLablist(result.data);
    } else {
      setLablist([]);
    }
  };

  const handleSelectedLab = (lab) => {
    setSelectedLab(lab);
    setLabName(lab.name);
    setLablist([]);
  };

  const handleDelete = (lab) => {
    if (appointmentDetails.status == 2) {
      setLabPrescription((prevData) =>
        prevData.map((item) =>
          item.labTestId === lab.labTestId ? { ...item, status: 0 } : item
        )
      );
    } else {
      setLabPrescription((prevData) =>
        prevData.filter((item) => item.labTestId !== lab.labTestId)
      );
    }
  };

  const handleSelectSuggLab = (labtest) => {
    fromSuggestionClick.current = true;
    setSelectedLab(labtest);
    setLabName(labtest.labTestName);
    setLablist([]);
    setSuggestiveLabList((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== labtest.id);
      }
      return prevState;
    });
  };

  const handleSuggDelete = (e, labtest) => {
    e.stopPropagation();
    setSuggestiveLabList((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== labtest.id);
      }
      return prevState;
    });
  };

  const handleAllLabSel = () => {
    for (const item of suggestiveLabList) {
      const labObj = {
        name: item.labTestName,
        code: item.labTestCode,
      };
      handleLabTestSave(labObj);
    }
    setSuggestiveLabList([]);
  };

  return (
    <div className="">
      <div className="h-[270px] overflow-y-scroll">
        <div className="flex w-full gap-5 p-3 relative ">
          <div className="flex flex-col space-y-2 w-full ">
            <div className="flex gap-2 relative">
              <input
                value={labName}
                onChange={(e) => {
                  handleLabChange(e.target.value);
                  onSearchLab(e.target.value);
                }}
                id="labname"
                type="text"
                placeholder=""
                className="w-1/2 p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] text-start peer  focus:border-[#189FAA] bg-transparent"
              />
              <label
                htmlFor="labname"
                className="text-xs font-medium font-sans text-[#333333]  absolute left-2 -top-2 transition-all peer-placeholder-shown:top-2 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-2 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
              >
                Test Name
              </label>

              <img
                src={Add}
                alt=""
                className="w-7 h-7 mt-1 cursor-pointer"
                id="addlabtest"
                role="button"
                onClick={() => handleLabTestSave(selectedLab)}
              />
            </div>
          </div>
          {labList.length > 0 && (
            <ul className="absolute top-full left-0 w-[80%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-10">
              {labList.map((lab, index) => (
                <li
                  onClick={() => handleSelectedLab(lab)}
                  key={lab.id || index}
                  className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                >
                  {lab.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          {suggestiveLabList &&
            suggestiveLabList?.map((labTest) => (
              <div
                className="flex items-center gap-1 cursor-pointer"
                onClick={() => handleSelectSuggLab(labTest)}
              >
                <div className="p-1 rounded-lg bg-brand-primaryColor text-white text-xs flex items-center gap-1">
                  <p className="m-0.5 p-0.5">{labTest.labTestName}</p>
                  <RxCross2
                    onClick={(e) => handleSuggDelete(e, labTest)}
                    className="text-xl rounded-[100%] p-1 border border-brand-lightBg"
                  />
                </div>
              </div>
            ))}
          {suggestiveLabList && suggestiveLabList.length !== 0 && (
            <div
              className="text-sm underline p-1 text-[#189FAA] text-center cursor-pointer"
              onClick={handleAllLabSel}
            >
              Select All
            </div>
          )}
        </div>

        {labPrescription && labPrescription.length > 0 && (
          <div className="flex flex-col w-full border-gray-300 rounded-lg shadow-md p-3">
            <div className="flex flex-col w-[70%] p-3">
              <div className="flex w-full bg-[#F5FEFA] text-[#333333] font-sans font-medium text-xs">
                <div className="p-2 border border-[#D2E1E2] text-left w-[85%]">
                  Lab Test Name
                </div>
                <div className="p-2 border border-[#D2E1E2] text-center w-[15%]">
                  Action
                </div>
              </div>

              {labPrescription && labPrescription.length > 0 && (
                <div className="w-full">
                  {labPrescription
                    .filter((lab) => lab?.status === 1)
                    .map((lab, index) => (
                      <div
                        key={index}
                        className="flex w-full text-[#189FAA] font-sans font-medium text-xs bg-white hover:bg-gray-100"
                      >
                        <div className="p-2 border border-gray-300 text-left w-[85%]">
                          {lab?.labTestName || "N/A"}
                        </div>

                        <div className="p-2 border flex justify-center items-center gap-3 border-gray-300 text-center w-[15%]">
                          <img
                            src={Delete}
                            alt="Delete"
                            className="w-4 h-4  cursor-pointer"
                            onClick={() => handleDelete(lab)}
                          />
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LabTest;
